module.exports = __webpack_public_path__ + "static/media/signatureFlo.81913526.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/standalone/originals/signatureFlo.svg
// module id = 181
// module chunks = 0